import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialGroupState: Dtos.TrialGroup & IRegistrationFormState = {
    id: null,
    trialId: null,
    trial: null,
    groupId: null,
    group: null,
    parentId: null,
    parent: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    administratesForGroupMembers: null,
    status: null,
    dateActivated: null,
    dateInvite: null,
    registrationEmails: null,
    randomisationEmails: null,
    screeningEmails: null,
    eligibilityEmails: null,
    saeEmails: null,
    trialGroupItemCategories: [],
    trialGroupItems: [],
    laboratories: [],
    children: [],
    personnel: []
}

export interface ITrialGroupReduxFormState {
    id: IFieldState<number>,
    trialId: IFieldState<number>,
    groupId: IFieldState<number>,
    parentId: IFieldState<number>,
    category: IFieldState<Dtos.Group>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>,
    administratesForGroupMembers: IFieldState<boolean>,
    status: IFieldState<number>,
    dateActivated: IFieldState<string>,
    dateInvite: IFieldState<string>,
    registrationEmails: IFieldState<string>,
    randomisationEmails: IFieldState<string>,
    screeningEmails: IFieldState<string>,
    eligibilityEmails: IFieldState<string>,
    saeEmails: IFieldState<string>,
    groupItemCategories: IFieldState<Dtos.GroupItemCategory[]>,
    trialGroupItems: IFieldState<Dtos.TrialGroupItem[]>,
    personnel: IFieldState<Dtos.TrialPersonnel[]>
}
